<template>
  <div class="ring-dnd">
    <van-nav-bar title="情景模式" :fixed="true" left-text="返回" :border="false" left-arrow @click-left="backPage" />
    <p class="ring-dnd-title">
      您可以基于设备的使用场景来设置不同的情景模式；
    </p>
    <div class="ring-down">
      <!-- <p>响铃模式</p> -->
      <div class="ring-box">
        <van-radio-group v-model="ringDown">
          <van-radio name="0,0">铃声</van-radio>
          <van-radio name="0,1">铃声加震动</van-radio>
          <!-- <van-radio name="1,1">震动</van-radio> -->
          <van-radio name="1,1">震动</van-radio>
        </van-radio-group>
      </div>
    </div>
    <!-- <div class="ring-down">
      <p>勿扰模式</p>
      <div class="ring-box">
        <van-radio-group v-model="dndMode">
          <van-radio name="0,0">不限制</van-radio>
          <van-radio name="1,0">限制呼入</van-radio>
          <van-radio name="0,1">限制呼出</van-radio>
          <van-radio name="1,1">限制呼入和呼出</van-radio>
        </van-radio-group>
      </div>
    </div> -->
    <div class="btn-box">
      <van-button round type="info" @click="save">保存</van-button>
    </div>
  </div>
</template>


<script>
export default {
  data () {
    return {
      needDelete:true,
      voiceList:[],
      ringDown:'0,1',
      dndMode:'0,0',
    }
  },
  created(){
    this.getProfileList()
  },
  methods: {
    /**
     * 返回上一级
     */
    backPage() {
        this.$router.back(-1);
    },
    //获取情景模式设置
    getProfileList(){
      console.log(999)
      let data = {
        ver:1,
        method:'getProfile',
        instructionId:this.$intfilter.instructFilter('情景模式'),
      }
      this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
          if (res.code === 0) {
            this.ringDown = res.data.ringMode
            this.dndMode = res.data.notDisturbMode
          }else{
            this.$toast({
              message: res.msg,
              duration: 2000,
              icon: require('@/assets/images/safety-fence/wrong.png'),
            });
          }
      })
    },
    //保存情景模式修改
    save(){
      let data = {
        ver:1,
        method:'sendProfile',
        instructionId:this.$intfilter.instructFilter('情景模式'),
        ringMode:this.ringDown,
        // notDisturbMode:this.dndMode,
        notDisturbMode:'0,0'
      }
      this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
          if (res.code === 0) {
            this.$toast({
              message: "保存成功",
              icon: "success"
            });
            setTimeout(()=>{
              this.getProfileList()
            },1500)
          }else{
            this.$toast({
              message: res.msg,
              duration: 2000,
              icon: require('@/assets/images/safety-fence/wrong.png'),
            });
          }
      })
    }
  },
}
</script>

<style scoped>
.ring-dnd{
  min-height: 100vh;
  background-color: #f8f8f8;
  padding: 130px 30px 120px;
}
.ring-dnd-title{
  font-size: 28px;
  color: #999999;
}
.ring-down{
  margin-top: 20px;
}
.ring-down>p{
  color: #323232;
  margin: 0 0 20px 10px;
}
.ring-box{
  padding: 30px 50px 30px 30px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 15px;
  font-size: 28px;
}
.btn-box{
  z-index: 1;
  position: fixed;
  width: 100%;
  padding: 20px 0 50px;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f8f8f8;
}
</style>
<style>
.ring-dnd .btn-box .van-button{
  margin: 0 auto;
  border: none;
  width: 586px;
  height: 98px;
  background: #01ADA9;
  color: #fff;
  border: 2px solid #01ADA9; 
}
.ring-dnd .van-radio{
  display: flex;
  flex-direction:row-reverse;
  height: 90px;
}
.ring-dnd .van-radio .van-radio__label{
  color: #999;
  flex: 1;
}
.ring-dnd .van-radio__icon--checked .van-icon{
  border: 1px solid #01ADA9;
  background: #01ADA9;
}
.ring-dnd .van-icon-success:before {
  /* color: #01ADA9;
  background-color: #fff; */
}
.ring-dnd .van-radio__icon--round{

}
</style>
